import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Import SCSS first (includes CSS variables) - must be before Tailwind
import './styles/index.scss';
// Import Tailwind CSS (can now use the CSS variables)
import './index.css';
// Other CSS imports
import 'nprogress/nprogress.css';
import './fonts/line-awesome-1.3.0/css/line-awesome.min.css';

import App from './App';
import { logoutOnUnauthorized, restoreSession } from './utils/jwt';
// import 'react-dates/initialize';
// import 'react-dates/lib/css/_datepicker.css';
// import reportWebVitals from './reportWebVitals';

const clientID = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'missing';

if (clientID === 'missing') {
  console.error('Missing clientID Google');
}

// Antes de montar nada: si hay una sesión válida guardada, dejar el token en el
// header por defecto de axios para que la primera request ya salga autenticada.
restoreSession();
logoutOnUnauthorized();

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement); // Crea un root
  root.render(
    <GoogleOAuthProvider clientId={clientID}>
      <App />
    </GoogleOAuthProvider>
  );
} else {
  console.error('Root element not found');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
